import { BrandLogo } from "@/components/shared/BrandLogo";

import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function PortalNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 glass border-b border-[var(--aur-border)]">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 lg:px-8">
        <Link to="/" data-testid="portal-brand-logo">
          <BrandLogo subtitle="Candidate Portal" size="h-10 w-10" text="text-xl" />
        </Link>
        <div className="flex items-center gap-4">
          <Link to="/careers" className="font-sans text-xs uppercase tracking-widest text-[var(--aur-text-2)] hover:text-gold">Browse Jobs</Link>
          <div className="hidden items-center gap-2 sm:flex">
            {user?.picture ? (
              <img src={user.picture} alt="" className="h-8 w-8 rounded-full object-cover" />
            ) : (
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gold/20 font-mono text-xs text-gold">
                {user?.name?.[0]?.toUpperCase()}
              </div>
            )}
            <span className="font-sans text-sm text-[var(--aur-text)]">{user?.name}</span>
          </div>
          <button onClick={doLogout} data-testid="portal-logout" className="flex items-center gap-1.5 rounded-full border border-[var(--aur-border)] px-3 py-1.5 font-sans text-xs text-[var(--aur-text-2)] hover:border-gold hover:text-gold">
            <LogOut size={13} /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
